import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';
import { IIdName } from '../_entities';

@Injectable()
export class AddressTypeService {

    addressTypeTemplates: Promise<IIdName[]>;

    constructor(private readonly httpService: HttpService) { }
    
    get templates(): Promise<IIdName[]> {
        if (!this.addressTypeTemplates) {
            this.addressTypeTemplates = this.httpService.get<IIdName[]>("api/addresstype/templates");
        }
        return this.addressTypeTemplates;
    }
}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/address-type.service.ts